import { createContext, useContext } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AccountContainerContext = createContext<any>({});

export const useAccountContainerContext = () => {
  return useContext(AccountContainerContext);
};
